export const NotePBType =
  "type.googleapis.com/firehydrant.nunc.TimelineEvent.Note";
export const MilestoneUpdatePBType =
  "type.googleapis.com/firehydrant.nunc.TimelineEvent.MilestoneUpdate";
export const BulkEventPBType =
  "type.googleapis.com/firehydrant.nunc.TimelineEvent.BulkImpactUpdate";
